import { client } from './client'

export default {
  index () {
    return client.get('/film-brands')
  }
}



// WEBPACK FOOTER //
// ./src/api/filmbrand.js